export default () => {
  return [
    {
      label: 'Нэр',
      name: 'name',
      className: 'col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
    {
      label: 'Улс',
      name: 'country',
      className: 'col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
    {
      label: 'Утас',
      name: 'phone',
      className: 'col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
    {
      label: 'Цахим Шуудан',
      name: 'email',
      className: 'col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
    {
      label: 'Хаяг',
      name: 'address',
      className: 'col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
    {
      label: 'Тайлбар',
      name: 'description',
      className: 'col-span-6 mb-0',
      inputProps: {
        className: 'w-full',
      }
    }
  ]
}